// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

.button {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  background: #aa004f;
  cursor: pointer;
  border-radius: 50px;
  text-transform: uppercase;
  font-size: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 25px;
  color: white;
  text-align: center;
  border: none;
  gap: 10px;
}
.button.white {
  background: white;
  color: #d02050;
}
.button.disabled {
  background: #bebebe;
}
.button.transparent {
  background: transparent;
  border: 1px solid #202121;
  color: #202121;
}
.button.pink {
  background: transparent;
  border: 1px solid #d02050;
  color: white;
}
.button.pink2 {
  background: transparent;
  border: 1px solid #d02050;
  color: #d02050;
}
.button.primary, .button.green {
  border: 0;
  color: white;
  gap: 5px;
  font-weight: initial;
  font-size: 1rem;
  background: #aa004f;
}
.button.green {
  background: #37AA1E;
}
.button.outline {
  cursor: pointer;
  border-radius: 50px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 35px;
  text-align: center;
  color: #aa004f;
  gap: 5px;
  font-weight: initial;
  font-size: 1rem;
  background: white;
  border: 1px solid #aa004f;
}
.button.outline:hover {
  color: white;
  background: #aa004f;
  border: 1px solid #aa004f;
}
.button.green-big {
  background: #37AA1E;
}
.button.md {
  font-size: 1.3rem;
}
.button.sm {
  font-size: 1rem;
}
.button.xs {
  font-size: 0.8rem;
  padding: 10px 25px;
}
.button:hover {
  opacity: 0.6;
}

@media (max-width: 992px) {
  .btn-next {
    font-size: 1rem;
    padding: 5px 10px;
  }
  .button {
    padding: 10px 35px;
  }
  .button.button-create-profile {
    padding: 10px 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/widgets/Button/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;AAnBA;EDDE,iCAAA;EACA,gBCCqB;EACrB,mBCKQ;EDJR,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AAuBF;AAtBE;EACE,iBAAA;EACA,cCpBK;AD4CT;AAtBE;EACE,mBClBK;AD0CT;AAtBE;EACE,uBAAA;EACA,yBAAA;EACA,cCpBM;AD4CV;AAtBE;EACE,uBAAA;EACA,yBAAA;EACA,YAAA;AAwBJ;AAtBE;EACE,uBAAA;EACA,yBAAA;EACA,cCtCK;AD8DT;AAtBE;EACE,SAAA;EACA,YAAA;EACA,QAAA;EACA,oBAAA;EACA,eAAA;EACA,mBCpCM;AD4DV;AAtBE;EAEE,mBCvCM;AD8DV;AArBE;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cCnDM;EDoDN,QAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAuBJ;AAtBI;EACE,YAAA;EACA,mBC3DI;ED4DJ,yBAAA;AAwBN;AArBE;EACE,mBC/DM;ADsFV;AArBE;EACE,iBAAA;AAuBJ;AArBE;EACE,eAAA;AAuBJ;AArBE;EACE,iBAAA;EACA,kBAAA;AAuBJ;AArBE;EACE,YAAA;AAuBJ;;AApBA;EACE;IACE,eAAA;IACA,iBAAA;EAuBF;EArBA;IACE,kBAAA;EAuBF;EArBE;IACE,6BAAA;EAuBJ;AACF","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints\";\n@import \"../../css/fonts\";\n@import \"../../css/colors\";\n\n.button {\n  @include font-roboto(900);\n  background: $color12;\n  cursor: pointer;\n  border-radius: 50px;\n  text-transform: uppercase;\n  font-size: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 25px;\n  color: white;\n  text-align: center;\n  border: none;\n  gap: 10px;\n  &.white {\n    background: white;\n    color: $color2;\n  }\n  &.disabled {\n    background: $color7;\n  }\n  &.transparent {\n    background: transparent;\n    border: 1px solid $color10;\n    color: $color10;\n  }\n  &.pink {\n    background: transparent;\n    border: 1px solid $color2;\n    color: white;\n  }\n  &.pink2 {\n    background: transparent;\n    border: 1px solid $color2;\n    color: $color2;\n  }\n  &.primary {\n    border: 0;\n    color: white;\n    gap: 5px;\n    font-weight: initial;\n    font-size: 1rem;\n    background: $color12;\n  }\n  &.green {\n    @extend .primary;\n    background: $color13;\n  }\n  &.outline {\n    cursor: pointer;\n    border-radius: 50px;\n    text-transform: uppercase;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 35px;\n    text-align: center;\n    color: $color12;\n    gap: 5px;\n    font-weight: initial;\n    font-size: 1rem;\n    background: white;\n    border: 1px solid $color12;\n    &:hover {\n      color: white;\n      background: $color12;\n      border: 1px solid $color12;\n    }\n  }\n  &.green-big {\n    background: $color13;\n  }\n  &.md {\n    font-size: 1.3rem;\n  }\n  &.sm {\n    font-size: 1rem;\n  }\n  &.xs {\n    font-size: 0.8rem;\n    padding: 10px 25px;\n  }\n  &:hover {\n    opacity: 0.6;\n  }\n}\n@media (max-width: 992px) {\n  .btn-next {\n    font-size: 1rem;\n    padding: 5px 10px;\n  }\n  .button {\n    padding: 10px 35px;\n    \n    &.button-create-profile{\n      padding: 10px 20px !important;\n    }\n  }\n \n}\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
